module.exports = __webpack_public_path__ + "img/search-black.26e353d2.png";